import {
  SHOW_BALANCE_FAILED,
  SHOW_BALANCE_SUCCESS,
  SHOW_BALANCE_INVALID_HASH,
  RESET_BALANCE,
  LOADING_BALANCE,
  SET_SELECTED_CURRENCY,
  // ADDEDIT_WALLET_SUCCESS,
  // ADD_BALANCE_SUCCESS,
  // WITHDRAW_MONEY_SUCCESS,
  // SEND_PENDINGLIST_SUCCESS,
  // BUY_PRODUCT_SUCCESS,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  isInvalidHash: false,
  data: {},
  selectedCurrency: "",
  selectedWalletId: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_BALANCE:
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        isInvalidHash: false,
      };
    case SHOW_BALANCE_FAILED:
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        isInvalidHash: false,
        data: action.payload,
        selectedCurrency: "",
      };
    case SHOW_BALANCE_INVALID_HASH:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        isInvalidHash: true,
        data: action.payload,
        selectedCurrency: "",
      };
    case SHOW_BALANCE_SUCCESS: {
      const {
        data: { walletBalanceList, ...rest },
        isFirstCall,
      } = action.payload;
      console.log("walletbalancelist = ", walletBalanceList);
      console.log("walletbalancelist = ", walletBalanceList.currency);

      const isDefaultValue = []
        .concat(walletBalanceList)
        .find(({ isDefault }) => isDefault === "Y");
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        isInvalidHash: false,
        data: {
          ...rest,
          walletBalanceList: [].concat(walletBalanceList),
        },
        selectedCurrency: isFirstCall
          ? isDefaultValue.currency
          : state.selectedCurrency,
        selectedWalletId: isFirstCall
          ? isDefaultValue.walletId
          : state.selectedWalletId,

        // selectedCurrency: [].concat(walletBalanceList).find(({ isDefault }) => isDefault === "Y").currency,
        // selectedWalletId: [].concat(walletBalanceList).find(({ isDefault }) => isDefault === "Y").walletId,
      };
    }

    // case ADDEDIT_WALLET_SUCCESS: {
    //   const { walletId, walletName, walletCurrency } = action.payload;
    //   const walletBalanceList = [...state.data.walletBalanceList];
    //   const newWalletBalanceList = [].concat(walletBalanceList).map((list) =>
    //     walletId === list.walletId
    //       ? {
    //           ...list,
    //           walletName: walletName ? walletName : `Wallet_${walletCurrency}`,
    //         }
    //       : list
    //   );
    //   return {
    //     ...state,
    //     data: {
    //       ...state.data,
    //       walletBalanceList: newWalletBalanceList,
    //     },
    //   };
    // }

    // case ADD_BALANCE_SUCCESS: {
    //   const { payload, currency } = action;
    //   const walletBalanceList = [...state.data.walletBalanceList];
    //   const newWalletBalanceList = [].concat(walletBalanceList).map((list) =>
    //     currency === list.currency
    //       ? {
    //           ...list,
    //           balance: Number(+list.balance + +payload).toFixed(2),
    //         }
    //       : list
    //   );
    //   return {
    //     ...state,
    //     data: {
    //       ...state.data,
    //       walletBalanceList: newWalletBalanceList,
    //     },
    //   };
    // }

    // case WITHDRAW_MONEY_SUCCESS: {
    //   const { payload, currency } = action;
    //   const walletBalanceList = [...state.data.walletBalanceList];
    //   const newWalletBalanceList = [].concat(walletBalanceList).map((list) =>
    //     currency === list.currency
    //       ? {
    //           ...list,
    //           balance: list.balance - payload.amount,
    //         }
    //       : list
    //   );
    //   return {
    //     ...state,
    //     data: {
    //       ...state.data,
    //       walletBalanceList: newWalletBalanceList,
    //     },
    //   };
    // }

    // case SEND_PENDINGLIST_SUCCESS: {
    //   const { amount } = action.payload.data;
    //   const walletBalanceList = [...state.data.walletBalanceList];
    //   const newWalletBalanceList = [].concat(walletBalanceList).map((list) =>
    //     list.isDefault === "Y"
    //       ? {
    //           ...list,
    //           balance: list.balance - amount,
    //         }
    //       : list
    //   );
    //   return {
    //     ...state,
    //     data: {
    //       ...state.data,
    //       walletBalanceList: newWalletBalanceList,
    //     },
    //   };
    // }

    // case BUY_PRODUCT_SUCCESS: {
    //   const {
    //     currency,
    //     purchase: { amount },
    //   } = action.payload;
    //   const walletBalanceList = [...state.data.walletBalanceList];
    //   const newWalletBalanceList = [].concat(walletBalanceList).map((list) =>
    //     list.currency === currency
    //       ? {
    //           ...list,
    //           balance: Number(list.balance - amount).toFixed(2),
    //         }
    //       : list
    //   );
    //   return {
    //     ...state,
    //     data: {
    //       ...state.data,
    //       walletBalanceList: newWalletBalanceList,
    //     },
    //   };
    // }

    case SET_SELECTED_CURRENCY: {
      return {
        ...state,
        selectedCurrency: action.payload,
        selectedWalletId: []
          .concat(state.data.walletBalanceList)
          .find(({ currency }) => currency === action.payload).walletId,
      };
    }

    case RESET_BALANCE:
      return (state = initialState);

    default:
      return state;
  }
};
